import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ErrorService } from '../services/error.service';
import { HttpError } from './http-error-codes';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private errorService = inject(ErrorService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        (_event: HttpEvent<unknown>) => {},
        (err: unknown) => {
          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              case HttpError.UnavailableForLegalReasons:
              case HttpError.BadRequest:
              case HttpError.Gone:
              case HttpError.NotFound:
              case HttpError.RequestEntityTooLarge:
                // BadRequest, Gone and NotFound are the responsability of the component to deal with
                break;
              case HttpError.Conflict:
                this.errorService.errors = ['http.conflict.error'];
                break;
              default:
                // We display a standard error message, use err.message to get the real message.
                this.errorService.errors = ['technical.error.has.occured'];
                break;
            }
          }
        }
      )
    );
  }
}
